import {memo, ShapeComponent, shapeComponent, Text, View} from "shared/base"
import React, {useMemo} from "react"
import AdminShowActions from "components/admin/show-actions"
import AttributeRow from "@kaspernj/api-maker/build/bootstrap/attribute-row"
import AttributeRows from "@kaspernj/api-maker/build/bootstrap/attribute-rows"
import ClassStepLink from "components/class-steps/link"
import ContactLink from "components/contacts/link"
import Nav from "./nav"
import {SchoolClass} from "models"
import SchoolLink from "components/schools/link"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useModel from "@kaspernj/api-maker/build/use-model"

export default memo(shapeComponent(class RoutesAdminSchoolClassesShow extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.school_classes.show"})
    const {schoolClass} = useModel(SchoolClass, {
      abilities: {
        SchoolClass: ["destroy", "edit"]
      },
      match: this.p.match,
      preload: ["class_step", "contact", "school"],
      select: {
        ClassStep: ["id", "name"],
        Contact: ["firstName", "id", "lastName", "name"],
        School: ["id", "name"],
        SchoolClass: ["createdAt", "deletedAt", "hasProSubscription", "id", "interpretedName", "schoolClassCheckInsCount", "updatedAt"]
      }
    })
    const {locale} = useI18n({namespace: "js.routes.admin.school_classes.show"})
    const actions = useMemo(
      () => <AdminShowActions model={schoolClass} />,
      [locale, schoolClass?.cacheKey()]
    )

    this.setInstance({schoolClass, t})
    useAdminLayout()?.setState({actions, active: "school-classes", headerTitle: schoolClass?.interpretedName()})
  }

  render() {
    const {schoolClass, t} = this.tt

    return (
      <View dataSet={{route: "admin/school-classes/show"}}>
        {schoolClass &&
          <>
            <Nav active="general" schoolClass={schoolClass} style={{marginBottom: 15}} />
            <AttributeRow attribute="name" model={schoolClass}>
              <Text>{schoolClass.interpretedName()}</Text>
            </AttributeRow>
            <AttributeRows attributes={["id", "schoolClassCheckInsCount", "createdAt", "updatedAt", "deletedAt"]} model={schoolClass} />
            <AttributeRow label={t(".has_pro_subscription")}>
              <Text>
                {schoolClass.hasProSubscription() ? t("js.shared.yes") : t("js.shared.no")}
              </Text>
            </AttributeRow>
            <AttributeRow label={SchoolClass.humanAttributeName("contact")}>
              {schoolClass.contact() &&
                <ContactLink adminLayout contact={schoolClass.contact()} />
              }
            </AttributeRow>
            <AttributeRow label={SchoolClass.humanAttributeName("school")}>
              {schoolClass.school() &&
                <SchoolLink adminLayout school={schoolClass.school()} />
              }
            </AttributeRow>
            <AttributeRow label={SchoolClass.humanAttributeName("classStep")}>
              {schoolClass.classStep() &&
                <ClassStepLink adminLayout classStep={schoolClass.classStep()} />
              }
            </AttributeRow>
          </>
        }
      </View>
    )
  }
}))
